// extracted by mini-css-extract-plugin
export default {"container":"carousel-mobile_container__QA6Da","prevArrow":"carousel-mobile_prevArrow__ONgFM","nextArrow":"carousel-mobile_nextArrow__VWWxD"};